import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslationService } from '../../../shell/translation-service';
// Rendered by standalone.routes.ts's wildcard routes — the standalone app's
// own "Standalone route-not-found handling" (no equivalent needed in
// app.routes.ts: the federated Shell owns route governance and unmatched
// paths there).
@Component({
  selector: 'ima-not-found-page',
  imports: [RouterLink],
  templateUrl: './not-found-page.html',
  styleUrl: './not-found-page.scss',
})
export class NotFoundPage {
  protected readonly i18n = inject(TranslationService);
}
